import { EntityManager } from "../../components/entityManager";
import { enmControlType, enmPropertyType, IMetadata } from "../../components/entityManager/interfaces";
import { IDocumentType, IDocumentTypeProps, IDocumentTypeStates } from "./interfaces";

export class DocumentType extends EntityManager<IDocumentType, IDocumentTypeProps, IDocumentTypeStates>{
    static initMetadata = (): IMetadata => {
        return {
            name: "DocumentType",
            title: "نوع مستند",
            Properties: [
                {
                    title: "نام",
                    dataIndex: "Name",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 250,
                    rules: [{ required: true, message: 'لطفا نام را وارد نمایید' }]
                },
                {
                    title: "کد",
                    dataIndex: "Code",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150,
                    rules: [{ required: true, message: 'لطفا کد را وارد نمایید' }],
                    showInLookup: false
                }
            ]
        };
    };
}